import React from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../../../hooks/use-services.hook";
import styled from "styled-components";
import {CardBox} from "../../../../../basic-components/card/card.box";
import {PrimaryButton} from "../../../../../basic-components/buttons/primary-button";
import {IonIcon} from "@ionic/react";
import {checkmark} from "ionicons/icons";
import {DialogCloseButtonBehavior} from "../../../../../services/dialog/dialog-enums";
import {InsuranceRefundDetailsDialog} from "./insurance-refund-details-dialog.component";

const SectionContainerBox = styled(CardBox)`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${props => props.theme.spacing.flexGap20};
    ${props => props.theme.containerMediaQuery.smallScreen} {
        flex-direction: column;
    }
`

const SectionContainerForClaimedInsuranceBox = styled(CardBox)`
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
`

const DetailsSectionBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    flex-grow: 1;
    gap: 2px;
`

const TitleBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${props => props.theme.spacing.flexGap16};
    color: ${props => props.theme.colors.primary};
    font-weight: ${props => props.theme.fontWeight.semiBold};
`

const OptionAddedBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    background-color: rgba(${props => props.theme.colors.primaryRgb}, 0.1);
    padding: ${props => props.theme.spacing.flexGap8} 
             ${props => props.theme.spacing.flexGap12} 
             ${props => props.theme.spacing.flexGap8} 
             ${props => props.theme.spacing.flexGap8};
    border-radius: calc(2 * ${props => props.theme.border.defaultRadius});
    font-size: ${props => props.theme.fontSize.body2};
`

const ButtonSectionBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    ${props => props.theme.containerMediaQuery.smallScreen} {
        width: 100%;
    }
`

export const ManageMyBookingInsuranceComponent: React.FC = observer(() => {
    const services = useServices();
    const booking = services.booking.current;

    if(!booking.insurance.hasInsurance) {
        return null;
    }

    if(booking.insurance.isClaimed) {
        return (
            <SectionContainerForClaimedInsuranceBox>
                <TitleBox>
                    {services.language.translate('Your cancellation request has been received.')}
                </TitleBox>

                <TitleBox dangerouslySetInnerHTML={
                    {
                        __html: services.language.translate('You will be contacted shortly with all details regarding the management of the <b>AeroFLEX</b> service.')
                    }
                }/>

            </SectionContainerForClaimedInsuranceBox>
        );

    }

    const onClaimInsurance = async () => {

        const refundDetails = await booking.insurance.getRefundDetails();

        await services.dialog.showStandardDialog({
            closeButtonBehavior: DialogCloseButtonBehavior.Reject,
            render: dialogHandler => (<InsuranceRefundDetailsDialog dialogHandler={dialogHandler} refundDetails={refundDetails} booking={booking}/>)
        });

    }

    return (
        <SectionContainerBox>
            <DetailsSectionBox>
                <TitleBox>
                    <span>
                        AeroFLEX
                    </span>
                    <OptionAddedBox>
                        <IonIcon icon={checkmark}/>
                        <span>
                            {services.language.translate('Option added')}
                        </span>
                    </OptionAddedBox>
                </TitleBox>
                <div dangerouslySetInnerHTML={{__html: services.language.translate('<b>Receive 80% of the booking value</b>, excluding taxes and the AeroFLEX fee.')}}>

                </div>
                <div>
                    {services.language.translate('Any refundable taxes will be reimbursed separately by Aeroitalia.')}
                </div>
            </DetailsSectionBox>
            <ButtonSectionBox>
                <PrimaryButton onClick={onClaimInsurance} fullWidth={true}>
                    {services.language.translate('Cancel my booking')}
                </PrimaryButton>
            </ButtonSectionBox>
        </SectionContainerBox>
    )
})